import React from 'react';

export const doneOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M11 18.5858L5.70711 13.2929C5.31658 12.9024 4.68342 12.9024 4.29289 13.2929C3.90237 13.6834 3.90237 14.3166 4.29289 14.7071L10.2929 20.7071C10.6834 21.0976 11.3166 21.0976 11.7071 20.7071L23.7071 8.70711C24.0976 8.31658 24.0976 7.68342 23.7071 7.29289C23.3166 6.90237 22.6834 6.90237 22.2929 7.29289L11 18.5858Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const partialOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='3' y='11' width='18' height='2' rx='1' fill='#023F80' />
    </svg>
  );
};

export const editOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M21.782 3.33539C20.9264 2.89941 19.9137 2.89941 19.0581 3.33539C18.6302 3.55338 18.2582 3.92633 17.8279 4.3578L4.67698 17.5088C4.32287 17.8628 4.06847 18.117 3.85947 18.4047C3.44206 18.9792 3.16654 19.6444 3.05545 20.3458C2.99983 20.697 2.99991 21.0567 3.00003 21.5573L3.00005 22.6L2.99985 22.681C2.99882 22.9628 2.99756 23.3091 3.09793 23.618C3.29577 24.2269 3.77314 24.7043 4.38201 24.9021C4.69094 25.0025 5.0373 25.0012 5.31907 25.0002L5.40005 25L6.44273 25C6.94338 25.0001 7.30306 25.0002 7.65425 24.9446C8.35566 24.8335 9.02081 24.558 9.59533 24.1406C9.883 23.9316 10.1373 23.6772 10.4912 23.3231L23.6422 10.1722C24.0737 9.74179 24.4466 9.36979 24.6646 8.94196C25.1006 8.08631 25.1006 7.07366 24.6646 6.21802C24.4467 5.79019 24.0737 5.4182 23.6423 4.98783L23.0122 4.35781C22.5819 3.92633 22.2099 3.55339 21.782 3.33539ZM19.9661 5.1174C20.2513 4.97208 20.5888 4.97208 20.874 5.1174C20.9796 5.17118 21.1114 5.2855 21.6928 5.86699L22.133 6.3072C22.7145 6.88868 22.8288 7.02045 22.8826 7.126C23.028 7.41121 23.028 7.74876 22.8826 8.03398C22.8288 8.13952 22.7145 8.27129 22.133 8.85278L21.275 9.7108L18.2892 6.72501L19.1473 5.86699C19.7287 5.2855 19.8605 5.17118 19.9661 5.1174ZM16.875 8.13922L6.14233 18.8719C5.71687 19.2974 5.58239 19.4359 5.4775 19.5803C5.24561 19.8994 5.09254 20.269 5.03083 20.6586C5.00291 20.8349 5.00005 21.0279 5.00005 21.6296V22.6C5.00005 22.797 5.00039 22.9048 5.00467 22.983L5.00536 22.9947L5.01702 22.9954C5.09529 22.9997 5.20302 23 5.40005 23H6.3704C6.97209 23 7.16513 22.9971 7.34138 22.9692C7.73105 22.9075 8.10058 22.7544 8.41976 22.5225C8.56413 22.4177 8.70266 22.2832 9.12812 21.8577L19.8608 11.125L16.875 8.13922Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const folderOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M9.52935 3.05253C9.30636 2.999 9.07932 2.99952 8.88745 2.99996L6.0646 3.00004C5.53473 3.00002 5.08355 3.00001 4.71312 3.03027C4.32396 3.06207 3.94536 3.1317 3.58343 3.31612C3.03776 3.59415 2.59412 4.03779 2.31608 4.58346C2.13167 4.9454 2.06203 5.32399 2.03024 5.71315C1.99997 6.08358 1.99999 6.53475 2 7.06461V15.9354C1.99999 16.4653 1.99997 16.9165 2.03024 17.2869C2.06204 17.6761 2.13167 18.0547 2.31608 18.4166C2.59412 18.9623 3.03776 19.4059 3.58343 19.684C3.94536 19.8684 4.32396 19.938 4.71312 19.9698C5.08354 20.0001 5.53472 20.0001 6.06458 20H17.9354C18.4652 20.0001 18.9164 20.0001 19.2869 19.9698C19.676 19.938 20.0546 19.8684 20.4165 19.684C20.9622 19.4059 21.4059 18.9623 21.6839 18.4166C21.8683 18.0547 21.9379 17.6761 21.9697 17.2869C22 16.9165 22 16.4653 22 15.9355V9.06463C22 8.53477 22 8.08358 21.9697 7.71316C21.9379 7.324 21.8683 6.9454 21.6839 6.58347C21.4059 6.0378 20.9622 5.59416 20.4165 5.31612C20.0546 5.13172 19.6761 5.06208 19.287 5.03028C18.9167 5.00001 18.4656 5.00003 17.9359 5.00004L12.1608 5.00004C12.0313 5.00004 11.9639 4.99983 11.914 4.99754C11.8661 4.99534 11.8806 5.00119 11.8452 4.96891C11.808 4.93497 11.7598 4.88702 11.6678 4.795L10.6047 3.73189L10.5693 3.69643C10.4341 3.5606 10.2741 3.39984 10.0786 3.28002C9.90855 3.17585 9.72322 3.09908 9.52935 3.05253ZM8.83727 4.80004C8.9674 4.80004 9.03542 4.80025 9.08572 4.80255C9.13363 4.80474 9.11929 4.79876 9.15474 4.8311C9.19184 4.86496 9.23997 4.91279 9.33187 5.00468L10.395 6.06779C10.5586 6.23188 10.7226 6.3982 10.9215 6.52006C11.0915 6.62423 11.2768 6.701 11.4707 6.74755C11.6968 6.80184 11.9297 6.8004 12.1608 6.80004H17.9005C18.4753 6.80004 18.8521 6.80074 19.1404 6.8243C19.4181 6.847 19.5334 6.88635 19.5994 6.91994C19.8063 7.0254 19.9746 7.19367 20.0801 7.40065C20.1137 7.46654 20.153 7.58189 20.1757 7.85973C20.1993 8.14808 20.2 8.52511 20.2 9.09998H3.8V7.10004C3.8 6.52513 3.8007 6.14808 3.82426 5.85973C3.84696 5.58188 3.88632 5.46654 3.91989 5.40065C4.02536 5.19367 4.19363 5.02539 4.40061 4.91993C4.4665 4.88636 4.58185 4.847 4.85969 4.8243C5.14805 4.80074 5.5251 4.80004 6.1 4.80004H8.83727ZM3.8 10.9V15.9C3.8 16.4749 3.8007 16.852 3.82426 17.1404C3.84696 17.4182 3.88632 17.5335 3.91989 17.5994C4.02536 17.8064 4.19363 17.9747 4.40061 18.0802C4.4665 18.1137 4.58185 18.1531 4.85969 18.1758C5.14805 18.1993 5.5251 18.2 6.1 18.2H17.9C18.4749 18.2 18.8519 18.1993 19.1403 18.1758C19.4181 18.1531 19.5335 18.1137 19.5994 18.0802C19.8063 17.9747 19.9746 17.8064 20.0801 17.5994C20.1137 17.5335 20.153 17.4182 20.1757 17.1404C20.1993 16.852 20.2 16.4749 20.2 15.9V10.9H3.8Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const likeOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.9918 4.00599C14.5405 4.06981 13.2389 4.64334 12.111 5.69952L11.994 5.813L11.8723 5.69501C10.6626 4.57606 9.2746 4 7.73438 4C4.57716 4 2 6.56027 2 9.71723C2 12.8046 3.12733 14.2688 8.18242 18.263L10.8704 20.3607C11.5345 20.8783 12.4655 20.8783 13.1296 20.3607L15.4937 18.5182L16.4269 17.7784C20.9647 14.144 22 12.676 22 9.71723C22 6.56027 19.4228 4 16.2656 4L15.9918 4.00599ZM16.2656 5.8C18.4314 5.8 20.2 7.55704 20.2 9.71723L20.1951 10.0108C20.1192 12.1674 19.1332 13.352 14.686 16.8631L12.0231 18.941C12.0095 18.9515 11.9905 18.9515 11.9769 18.941L9.6128 17.0984L8.73899 16.4066C4.59678 13.0977 3.8 11.9668 3.8 9.71723C3.8 7.55704 5.56863 5.8 7.73438 5.8C9.06729 5.8 10.2408 6.41758 11.3038 7.71525C11.6662 8.15771 12.3441 8.15426 12.702 7.70812C13.7389 6.41565 14.9087 5.8 16.2656 5.8Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const crossShieldOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M11.6974 2.15241C11.8931 2.0825 12.1071 2.0825 12.3028 2.15241L19.3028 4.65241C19.661 4.78033 19.9001 5.11962 19.9001 5.49998V13C19.9001 15.8507 18.3319 18.0768 16.6572 19.5506C15.8145 20.2922 14.9201 20.8668 14.1257 21.2598C13.3682 21.6345 12.5894 21.9 12.0001 21.9C11.4108 21.9 10.632 21.6345 9.87452 21.2598C9.08005 20.8668 8.18569 20.2922 7.34303 19.5506C5.66825 18.0768 4.1001 15.8507 4.1001 13V5.49998C4.1001 5.11962 4.3392 4.78033 4.69739 4.65241L11.6974 2.15241ZM5.9001 6.13422V13C5.9001 15.1493 7.08194 16.9231 8.53216 18.1993C9.25201 18.8328 10.0139 19.3206 10.6726 19.6464C11.3682 19.9905 11.8394 20.1 12.0001 20.1C12.1608 20.1 12.632 19.9905 13.3276 19.6464C13.9863 19.3206 14.7482 18.8328 15.468 18.1993C16.9183 16.9231 18.1001 15.1493 18.1001 13V6.13422L12.0001 3.95565L5.9001 6.13422Z'
        fill='#023F80'
      />
      <path
        d='M10.1365 8.86358C9.78502 8.51211 9.21517 8.51211 8.8637 8.86358C8.51223 9.21505 8.51223 9.7849 8.8637 10.1364L10.7273 12L8.8637 13.8636C8.51223 14.2151 8.51223 14.7849 8.8637 15.1364C9.21517 15.4878 9.78502 15.4878 10.1365 15.1364L12.0001 13.2728L13.8637 15.1364C14.2152 15.4878 14.785 15.4878 15.1365 15.1364C15.488 14.7849 15.488 14.2151 15.1365 13.8636L13.2729 12L15.1365 10.1364C15.488 9.7849 15.488 9.21505 15.1365 8.86358C14.785 8.51211 14.2152 8.51211 13.8637 8.86358L12.0001 10.7272L10.1365 8.86358Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const homeOutline = (props) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        id='Vector'
        d='M12.6666 14H3.33329C3.15648 14 2.98691 13.9298 2.86189 13.8048C2.73686 13.6797 2.66663 13.5102 2.66663 13.3334V7.33336H0.666626L7.55129 1.07469C7.67403 0.963013 7.83401 0.901123 7.99996 0.901123C8.1659 0.901123 8.32589 0.963013 8.44863 1.07469L15.3333 7.33336H13.3333V13.3334C13.3333 13.5102 13.2631 13.6797 13.138 13.8048C13.013 13.9298 12.8434 14 12.6666 14ZM3.99996 12.6667H12V6.10469L7.99996 2.46869L3.99996 6.10469V12.6667Z'
        fill='#2C3436'
      />
    </svg>
  );
};

export const deleteOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M14.5561 8.10176C15.0522 8.13276 15.4292 8.56006 15.3982 9.05615L14.8982 17.0561C14.8672 17.5522 14.4399 17.9293 13.9438 17.8983C13.4477 17.8672 13.0707 17.44 13.1017 16.9439L13.6017 8.94387C13.6327 8.44778 14.06 8.07075 14.5561 8.10176Z'
        fill='#023F80'
      />
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M9.44383 8.10176C8.94775 8.13276 8.57072 8.56006 8.60173 9.05615L9.10173 17.0561C9.13273 17.5522 9.56003 17.9293 10.0561 17.8983C10.5522 17.8672 10.9292 17.44 10.8982 16.9439L10.3982 8.94387C10.3672 8.44778 9.93992 8.07075 9.44383 8.10176Z'
        fill='#023F80'
      />
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M2.99998 4.10001C2.50292 4.10001 2.09998 4.50295 2.09998 5.00001C2.09998 5.49706 2.50292 5.90001 2.99998 5.90001H4.1804L5.33503 18.216C5.38037 18.6998 5.41917 19.1138 5.47805 19.4533C5.54018 19.8116 5.63499 20.1567 5.82894 20.4827C6.12314 20.9772 6.55781 21.3731 7.07764 21.6198C7.42033 21.7825 7.77278 21.8447 8.13527 21.8731C8.47885 21.9 8.89467 21.9 9.38064 21.9H14.6193C15.1053 21.9 15.5211 21.9 15.8647 21.8731C16.2272 21.8447 16.5796 21.7825 16.9223 21.6198C17.4421 21.3731 17.8768 20.9772 18.171 20.4827C18.365 20.1567 18.4598 19.8116 18.5219 19.4533C18.5808 19.1138 18.6196 18.6998 18.6649 18.216L19.8195 5.90001H21C21.497 5.90001 21.9 5.49706 21.9 5.00001C21.9 4.50295 21.497 4.10001 21 4.10001H15.7956C15.3893 2.37999 13.8441 1.10001 12 1.10001C10.1558 1.10001 8.61063 2.37999 8.20434 4.10001H2.99998ZM7.12405 18.0147C7.17339 18.541 7.2062 18.8841 7.25158 19.1458C7.29507 19.3965 7.33946 19.5012 7.37589 19.5624C7.48748 19.75 7.65236 19.9001 7.84953 19.9937C7.91391 20.0243 8.02222 20.0587 8.27594 20.0786C8.54075 20.0994 8.88544 20.1 9.41401 20.1H14.5859C15.1145 20.1 15.4592 20.0994 15.724 20.0786C15.9777 20.0587 16.086 20.0243 16.1504 19.9937C16.3476 19.9001 16.5125 19.75 16.6241 19.5624C16.6605 19.5012 16.7049 19.3965 16.7484 19.1458C16.7938 18.8841 16.8266 18.541 16.8759 18.0147L18.0117 5.90001H5.9883L7.12405 18.0147ZM12 2.90001C11.1623 2.90001 10.4391 3.39052 10.1021 4.10001H13.8979C13.5608 3.39052 12.8377 2.90001 12 2.90001Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const infoCircleOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4ZM14.0736 12C14.3112 12 14.4604 12.0371 14.5907 12.1069C14.7211 12.1766 14.8234 12.2789 14.8931 12.4093C14.9629 12.5396 15 12.6888 15 12.9264V19.0736C15 19.3112 14.9629 19.4604 14.8931 19.5907C14.8234 19.7211 14.7211 19.8234 14.5907 19.8931C14.4604 19.9629 14.3112 20 14.0736 20H13.9264C13.6888 20 13.5396 19.9629 13.4093 19.8931C13.2789 19.8234 13.1766 19.7211 13.1069 19.5907C13.0371 19.4604 13 19.3112 13 19.0736V12.9264C13 12.6888 13.0371 12.5396 13.1069 12.4093C13.1766 12.2789 13.2789 12.1766 13.4093 12.1069C13.5396 12.0371 13.6888 12 13.9264 12H14.0736ZM14 7.6C14.7732 7.6 15.4 8.2268 15.4 9C15.4 9.7732 14.7732 10.4 14 10.4C13.2268 10.4 12.6 9.7732 12.6 9C12.6 8.2268 13.2268 7.6 14 7.6Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const dashboardOutline = (props) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        id='vector'
        d='M2.66667 7.33333C2.47778 7.33333 2.31944 7.26944 2.19167 7.14167C2.06389 7.01389 2 6.85556 2 6.66667V2.66667C2 2.47778 2.06389 2.31944 2.19167 2.19167C2.31944 2.06389 2.47778 2 2.66667 2H6.66667C6.85556 2 7.01389 2.06389 7.14167 2.19167C7.26944 2.31944 7.33333 2.47778 7.33333 2.66667V6.66667C7.33333 6.85556 7.26944 7.01389 7.14167 7.14167C7.01389 7.26944 6.85556 7.33333 6.66667 7.33333H2.66667ZM9.33333 7.33333C9.14444 7.33333 8.98611 7.26944 8.85833 7.14167C8.73056 7.01389 8.66667 6.85556 8.66667 6.66667V2.66667C8.66667 2.47778 8.73056 2.31944 8.85833 2.19167C8.98611 2.06389 9.14444 2 9.33333 2H13.3333C13.5222 2 13.6806 2.06389 13.8083 2.19167C13.9361 2.31944 14 2.47778 14 2.66667V6.66667C14 6.85556 13.9361 7.01389 13.8083 7.14167C13.6806 7.26944 13.5222 7.33333 13.3333 7.33333H9.33333ZM2.66667 14C2.47778 14 2.31944 13.9361 2.19167 13.8083C2.06389 13.6806 2 13.5222 2 13.3333V9.33333C2 9.14444 2.06389 8.98611 2.19167 8.85833C2.31944 8.73056 2.47778 8.66667 2.66667 8.66667H6.66667C6.85556 8.66667 7.01389 8.73056 7.14167 8.85833C7.26944 8.98611 7.33333 9.14444 7.33333 9.33333V13.3333C7.33333 13.5222 7.26944 13.6806 7.14167 13.8083C7.01389 13.9361 6.85556 14 6.66667 14H2.66667ZM11.3333 14C11.1444 14 10.9861 13.9361 10.8583 13.8083C10.7306 13.6806 10.6667 13.5222 10.6667 13.3333V12H9.31667C9.12778 12 8.97222 11.9361 8.85 11.8083C8.72778 11.6806 8.66667 11.5222 8.66667 11.3333C8.66667 11.1444 8.73056 10.9861 8.85833 10.8583C8.98611 10.7306 9.14444 10.6667 9.33333 10.6667H10.6667V9.31667C10.6667 9.12778 10.7306 8.97222 10.8583 8.85C10.9861 8.72778 11.1444 8.66667 11.3333 8.66667C11.5222 8.66667 11.6806 8.73056 11.8083 8.85833C11.9361 8.98611 12 9.14444 12 9.33333V10.6667H13.35C13.5389 10.6667 13.6944 10.7306 13.8167 10.8583C13.9389 10.9861 14 11.1444 14 11.3333C14 11.5222 13.9361 11.6806 13.8083 11.8083C13.6806 11.9361 13.5222 12 13.3333 12H12V13.35C12 13.5389 11.9361 13.6944 11.8083 13.8167C11.6806 13.9389 11.5222 14 11.3333 14ZM10 3.33333V6H12.6667V3.33333H10ZM3.33333 3.33333V6H6V3.33333H3.33333ZM3.33333 10V12.6667H6V10H3.33333Z'
        fill='#334155'
      />
    </svg>
  );
};

export const checkCircleOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14.9637 9.2636C15.3152 8.91213 15.885 8.91213 16.2365 9.2636C16.588 9.61508 16.588 10.1849 16.2365 10.5364L11.6365 15.1364C11.285 15.4879 10.7152 15.4879 10.3637 15.1364L7.7637 12.5364C7.41222 12.1849 7.41222 11.6151 7.7637 11.2636C8.11517 10.9121 8.68502 10.9121 9.03649 11.2636L11.0001 13.2272L14.9637 9.2636Z'
        fill='#023F80'
      />
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M12.0001 2.09998C17.4672 2.09998 21.9001 6.53285 21.9001 12C21.9001 17.4671 17.4672 21.9 12.0001 21.9C6.53297 21.9 2.1001 17.4671 2.1001 12C2.1001 6.53285 6.53298 2.09998 12.0001 2.09998ZM12.0001 3.89998C7.52609 3.89998 3.9001 7.52597 3.9001 12C3.9001 16.474 7.52609 20.1 12.0001 20.1C16.4741 20.1 20.1001 16.474 20.1001 12C20.1001 7.52597 16.4741 3.89998 12.0001 3.89998Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const warningTriangleOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M9.48854 4.55004C10.6047 2.6167 13.3953 2.6167 14.5115 4.55004L21.4397 16.55C22.5559 18.4834 21.1606 20.9 18.9282 20.9H5.07181C2.83939 20.9 1.44412 18.4834 2.56033 16.55L9.48854 4.55004ZM12.9526 5.45004C12.5292 4.7167 11.4708 4.7167 11.0474 5.45004L4.11918 17.45C3.69579 18.1834 4.22503 19.1 5.07181 19.1H18.9282C19.775 19.1 20.3042 18.1834 19.8808 17.45L12.9526 5.45004Z'
        fill='#023F80'
      />
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M12 8.00007C12.4971 8.00007 12.9 8.37423 12.9 8.83578L12.9 13.6644C12.9 14.1259 12.497 14.5001 12 14.5001C11.5029 14.5001 11.1 14.1259 11.1 13.6644L11.1 8.83578C11.1 8.37423 11.503 8.00007 12 8.00007Z'
        fill='#023F80'
      />
      <path
        d='M13 16.5001C13 17.0524 12.5523 17.5001 12 17.5001C11.4477 17.5001 11 17.0524 11 16.5001C11 15.9478 11.4477 15.5001 12 15.5001C12.5523 15.5001 13 15.9478 13 16.5001Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const riskOutline = (props) => {
  return (
    <svg
      width='22'
      height='20'
      viewBox='0 0 22 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M2.16104 2.46901C3.32111 1.30874 4.87704 0.630098 6.51664 0.569262C8.15624 0.508427 9.75819 1.0699 11.001 2.14101C12.2428 1.07168 13.8426 0.510843 15.4803 0.570774C17.1179 0.630705 18.6724 1.30698 19.8327 2.46422C20.993 3.62145 21.6733 5.17424 21.7375 6.8117C21.8018 8.44917 21.2451 10.0505 20.179 11.295L12.414 19.085C12.0573 19.4419 11.5788 19.6507 11.0746 19.6696C10.5703 19.6886 10.0775 19.5162 9.69504 19.187L9.58504 19.086L1.82104 11.295C0.755532 10.0515 0.198622 8.45172 0.261658 6.81539C0.324693 5.17907 1.00303 3.62683 2.16104 2.46901ZM3.57504 3.88301C2.75728 4.701 2.2859 5.80245 2.25871 6.95878C2.23152 8.11511 2.65063 9.2375 3.42904 10.093L3.57504 10.247L11 17.672L16.303 12.368L12.768 8.83301L11.708 9.89301C11.4295 10.1717 11.0988 10.3928 10.7348 10.5436C10.3709 10.6945 9.98075 10.7722 9.58675 10.7723C8.79103 10.7725 8.02783 10.4565 7.46504 9.89401C6.90225 9.33149 6.58598 8.56844 6.58579 7.77272C6.5856 6.977 6.90152 6.2138 7.46404 5.65101L9.56604 3.54801C8.72951 2.88039 7.68245 2.5327 6.61273 2.56734C5.543 2.60198 4.52063 3.01667 3.72904 3.73701L3.57504 3.88301ZM12.061 6.71101C12.2486 6.52354 12.5029 6.41823 12.768 6.41823C13.0332 6.41823 13.2875 6.52354 13.475 6.71101L17.717 10.953L18.425 10.247C19.2565 9.41615 19.7299 8.29293 19.7439 7.11757C19.7579 5.94222 19.3115 4.80803 18.5001 3.95757C17.6887 3.1071 16.5767 2.60788 15.402 2.56667C14.2273 2.52545 13.0831 2.94551 12.214 3.73701L12.061 3.88301L8.87904 7.06501C8.70571 7.23823 8.60202 7.46905 8.58764 7.71368C8.57326 7.9583 8.6492 8.19968 8.80104 8.39201L8.87904 8.47901C9.05226 8.65234 9.28309 8.75604 9.52771 8.77042C9.77233 8.78479 10.0137 8.70886 10.206 8.55701L10.293 8.47901L12.061 6.71101Z'
        fill='#121414'
      />
    </svg>
  );
};

export const originationOutline = (props) => {
  return (
    <svg width="22" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clip-path="url(#clip0_4007_8000)">
        <path d="M6 3C9.49 3 12.383 5.554 12.913 8.895C14.088 7.724 15.71 7 17.5 7H22V9.5C22 13.09 19.09 16 15.5 16H13V21H11V13H9C5.134 13 2 9.866 2 6V3H6ZM20 9H17.5C15.015 9 13 11.015 13 13.5V14H15.5C17.985 14 20 11.985 20 9.5V9ZM6 5H4V6C4 8.761 6.239 11 9 11H11V10C11 7.239 8.761 5 6 5Z" fill="#3D434C" />
      </g>
      <defs>
        <clipPath id="clip0_4007_8000">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const quillPenOutline = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_11319_173)">
        <path d="M6.94 14.036C6.707 14.66 6.51 15.236 6.334 15.819C7.294 15.122 8.435 14.68 9.752 14.515C12.265 14.201 14.498 12.542 15.628 10.457L14.172 9.002L15.585 7.587L16.585 6.586C17.015 6.156 17.5 5.362 18.013 4.218C12.42 5.085 8.995 8.51 6.939 14.036H6.94ZM17 9.001L18 10C17 13 14 16 10 16.5C7.331 16.834 5.664 18.667 4.998 22H3C4 16 6 2 21 2C20 4.997 19.002 6.996 18.003 7.997L17 9.001Z" fill="#234E52" />
      </g>
      <defs>
        <clipPath id="clip0_11319_173">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const clockOutline = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12.4 7.99998C12.4 7.50292 11.997 7.09998 11.5 7.09998C11.0029 7.09998 10.6 7.50292 10.6 7.99998V12.5C10.6 12.8751 10.8327 13.2109 11.184 13.3427L15.184 14.8427C15.6494 15.0172 16.1681 14.7814 16.3427 14.316C16.5172 13.8506 16.2814 13.3318 15.816 13.1573L12.4 11.8763V7.99998Z" fill="#023F80" />
      <path fill-rule="evenodd" clipRule="evenodd" d="M12 2.09998C6.53236 2.09998 2.09998 6.53236 2.09998 12C2.09998 17.4676 6.53236 21.9 12 21.9C17.4676 21.9 21.9 17.4676 21.9 12C21.9 6.53236 17.4676 2.09998 12 2.09998ZM3.89998 12C3.89998 7.52647 7.52647 3.89998 12 3.89998C16.4735 3.89998 20.1 7.52647 20.1 12C20.1 16.4735 16.4735 20.1 12 20.1C7.52647 20.1 3.89998 16.4735 3.89998 12Z" fill="#023F80" />
    </svg>
  )
}


